import Datepicker from 'vuejs-datepicker';
import { format } from 'date-fns';

export default {
  name: 'GcDatePicker',
  components: {
    Datepicker,
  },
  data() {
    return {
      className: 'gc__date-picker',
    };
  },
  computed: {
    fieldClassName() {
      return `${this.className}__field`;
    },
    labelClassName() {
      return `${this.className}__label`;
    },
    requiredClassName() {
      return this.required ? `${this.className}__required` : '';
    },
    disabledClassName() {
      return this.disabled ? `${this.className}__disabled` : '';
    },
    hideLabelClassName() {
      return this.hideLabel ? `${this.className}--hidden` : '';
    },
    uniqueId() {
      return `${this.className}--${Math.round(Math.random() * 100000)}`;
    },
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Date, String],
      default: null,
    },
    typeable: {
      type: Boolean,
      default: false,
    },
    disabledDates: {
      type: Object,
      default: () => {},
    },
    highlightedDates: {
      type: Object,
      default: () => {},
    },
    dateFormat: {
      type: String,
      default: 'MM-dd-yyyy',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    styleObject: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },
  methods: {
    openPicker() {
      // Need to be able to open when tabbing to the input.
      // Still work in progress.
      this.$refs.programaticOpen.showCalendar();
    },
    formatDate(date) {
      if (!date) return '';
      // Method to format date based on value provided.
      return format(new Date(date), this.dateFormat);
    },
  },
};
